import { useEffect, useState } from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import testimonialUserImg from "../../../assets-user/testimonialUser.png";

const ExploreTestimonials = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const testimonials = [
    {
      id: 1,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "Aditya Singh",
      company: "ASK Builders",
      rating: 4,
      image: testimonialUserImg,
    },
    {
      id: 2,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "Priya Sharma",
      company: "Prime Realty",
      rating: 5,
      image: testimonialUserImg,
    },
    // {
    //   id: 3,
    //   quote:
    //     "Outstanding results! We've seen a significant increase in quality leads.",
    //   name: "Rajesh Kumar",
    //   company: "Urban Developments",
    //   rating: 4,
    //   image: testimonialUserImg,
    // },
  ];

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js";
    script.async = true;
    script.onload = () => {
      window.AOS.init({
        duration: 800,
        offset: 100,
        once: true,
        easing: "ease-in-out-cubic",
      });
    };
    document.body.appendChild(script);

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.css";
    document.head.appendChild(link);

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);

  const renderStars = (rating) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, index) => (
          <FaStar
            key={index}
            className={`w-4 h-4 ${
              index < rating ? "text-yellow-400" : "text-gray-300"
            }`}
          />
        ))}
      </div>
    );
  };

  const getGridClass = () => {
    if (width < 640) return "grid-cols-1";
    if (width < 1024) return "grid-cols-2";
    if (width < 1280) return "grid-cols-2";
    return "grid-cols-2";
  };

  return (
    <div className="relative">
      <div
        className={`grid ${getGridClass()} gap-4 sm:gap-5 lg:gap-6 max-w-7xl mx-auto`}
      >
        {testimonials.map((testimonial, index) => (
          <div
            key={testimonial.id}
            data-aos="fade-up"
            data-aos-delay={index * 100}
            data-aos-duration="700"
            className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-6 hover:shadow-lg transition-shadow duration-300"
          >
            <div className="flex gap-4 sm:gap-5 md:gap-6">
              <div
                data-aos="zoom-in"
                data-aos-delay={index * 100 + 100}
                className="w-12 h-12 bg-black rounded-xl flex items-center justify-center flex-shrink-0"
              >
                <FaQuoteLeft className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <p
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 150}
                  className="text-sm sm:text-base md:text-lg font-normal text-gray-600"
                >
                  {testimonial.quote}
                </p>
              </div>
            </div>

            <div className="border w-full my-4"></div>

            <div className="flex items-center gap-4">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                data-aos="zoom-in"
                data-aos-delay={index * 100 + 200}
                className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover flex-shrink-0"
              />

              <div className="flex-1 min-w-0">
                <h4
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 250}
                  className="text-sm sm:text-base md:text-lg font-semibold truncate"
                >
                  {testimonial.name}
                </h4>
                <p
                  data-aos="fade-up"
                  data-aos-delay={index * 100 + 300}
                  className="text-xs sm:text-sm text-gray-500 truncate"
                >
                  {testimonial.company}
                </p>
                <div data-aos="fade-up" data-aos-delay={index * 100 + 350}>
                  {renderStars(testimonial.rating)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreTestimonials;
